<template>
    <div class="resume-page max-content" v-if="passedLogin">
        <van-sticky>
            <top title="我的简历" :color="color"></top>
        </van-sticky>
        <van-loading v-if="!loaded" class="page-loading" type="spinner" color="#901D22" />
        <template v-else-if="bound">
            <div class="resume-body">
                <div class="profile">
                    <img :src="photoSrc" alt="" @error="onImgError">
                    <div class="meta">
                        <p class="name">{{ resume.name }}</p>
                        <p class="hospital">{{ resume.hospital }}</p>
                    </div>
                </div>
                <div class="deadline" v-if="deadlineText">简历更新于{{ deadlineText }}截止</div>
                <p class="intro">{{ resume.intro }}</p>
            </div>
            <div class="bottom-btn">
                <button type="button" class="primary-btn" @click="goEdit">
                    <van-icon name="edit" color="#fff" size="16px" />
                    <span>简介更新</span>
                </button>
            </div>
        </template>
        <div v-else-if="loadFailed" class="empty">
            <p>简历加载失败</p>
        </div>
        <div v-else class="empty">
            <img src="//cdn.edstatic.com/203012120000/0c943a975a9bdd5efacded516dcbda52/2026/10/bd0c92c1-2160-446b-b2d2-4ee819eb8307.webp"
                alt="">
            <p>您登录的账号<br>在此会议中暂无简历</p>
        </div>
    </div>
</template>
<script>
import Top from "../components/Top";
import { ensureLogin, fetchExpertResume, consumeSavedTip, formatResumeDeadline, isResumeClosed, consumeResumeClosedTip } from "./resumeMock";
import { NewMeetingDetail } from "../../../config/interface";
export default {
    components: {
        Top
    },
    data() {
        return {
            passedLogin: false,
            loaded: false,
            loadFailed: false,
            bound: false,
            resume: {
                name: "",
                hospital: "",
                intro: "",
                photo: "",
                resume_end_time: ""
            },
            color: "#901D22",
            theme_color: "#901D22",
            defaultPhoto: require("@/assets/images/default_user.png")
        };
    },
    computed: {
        meetingId() {
            return this.$route.query.meeting_id || this.$route.query.id || this.$route.query.MT_id || "";
        },
        photoSrc() {
            return this.resume.photo || this.defaultPhoto;
        },
        deadlineText() {
            return formatResumeDeadline(this.resume.resume_end_time);
        }
    },
    created() {
        this.init();
        this.getMeetingDetailsNew(this.meetingId);
    },
    methods: {
        getMeetingDetailsNew(id) {
            fetch(NewMeetingDetail(id), {}, "GET").then((res) => {
                if (res.code == 0) {
                    let data = res.data;
                    document.title = data.name;
                    if (res.data.theme_color_hex) {
                        this.color = res.data.theme_color_hex;
                    } else {
                        this.color = "#901D22";
                    }
                }
            });
        },
        init() {
            ensureLogin(this).then((user) => {
                if (!user) {
                    return;
                }
                this.passedLogin = true;
                fetchExpertResume(this.meetingId).then((data) => {
                    if (!data.ok) {
                        this.loadFailed = true;
                        this.$toast(data.message || "获取简历失败");
                    } else {
                        this.bound = !!data.bound;
                        if (data.bound) {
                            this.resume = data;
                        }
                    }
                    this.loaded = true;
                    this.$nextTick(() => {
                        if (consumeSavedTip()) {
                            this.showResumeToast("信息已修改");
                        } else if (consumeResumeClosedTip()) {
                            this.showResumeToast("简历更新已截止");
                        }
                    });
                });
            });
        },
        onImgError(event) {
            event.target.src = this.defaultPhoto;
        },
        goEdit() {
            if (isResumeClosed(this.resume.resume_end_time)) {
                this.showResumeToast("简历更新已截止");
                return;
            }
            this.$router.push({
                path: "/vascularNews/expert/edit",
                query: {
                    meeting_id: this.meetingId
                }
            });
        },
        showResumeToast(message) {
            this.$toast({
                message: message,
                duration: 1600,
                className: "resume-saved-toast"
            });
        }
    }
};
</script>
<style scoped lang="scss">
.resume-page {
    height: 100vh;
    background: #f7f7f7;
    display: flex;
    flex-direction: column;

    /deep/ .van-nav-bar__right span {
        display: none;
    }
}

.page-loading {
    margin: 80px auto;
}

.resume-body {
    flex: 1;
    padding-bottom: 20px;
    overflow: auto;
}

.profile {
    display: flex;
    align-items: flex-start;
    padding: 18px 16px 18px;
    background: #ffffff;


    img {
        width: 92px;
        height: 92px;
        object-fit: cover;
        flex-shrink: 0;
        background: #f3f3f3;
    }

    .meta {
        margin-left: 14px;
        padding-top: 6px;
        min-width: 0;
    }

    .name {
        font-size: 18px;
        font-weight: 600;
        color: #222;
        line-height: 26px;
    }

    .hospital {
        margin-top: 8px;
        font-size: 13px;
        color: #9b9b9b;
        line-height: 20px;
    }
}

.deadline {
    margin: 15px 16px 8px;
    padding: 12px 8px;
    background: #FFE6E7;
    border-radius: 8px;
    text-align: center;
    color:#901D22;
    font-size: 14px;
    line-height: 20px;
    border: 0.5px solid #FFCBCD;
}

.intro {
    padding: 12px 16px 0;
    font-size: 15px;
    color: #4a4a4a;
    line-height: 26px;
    white-space: pre-wrap;
    word-break: break-word;
}

.bottom-btn {
    // position: fixed;
    // left: 50%;
    // bottom: 0;
    // transform: translateX(-50%);
    width: 100%;
    max-width: 600px;
    box-sizing: border-box;
    padding: 20px 24px 30px;
    // background: #fff;

}

.primary-btn {
    width: 90%;
    margin: 0 auto;
    height: 46px;
    border: none;
    border-radius: 24px;
    background: #901D22;
    color: #fff;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
        color: #fff;
        font-size: 16px;
        line-height: 16px;
    }

    .van-icon {
        margin-right: 6px;
        color: #fff;
        font-size: 16px;
    }
}

.empty {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 80px;

    img {
        width: 160px;
        height: auto;
    }

    .empty-illu {
        width: 168px;
        height: 122px;
    }

    p {
        margin-top: 18px;
        color: #c8c8c8;
        font-size: 15px;
        line-height: 26px;
        text-align: center;
    }
}
</style>
<style lang="scss">
.resume-saved-toast.van-toast {
    width: auto;
    min-width: 112px;
    padding: 12px 18px;
    background: rgba(60, 60, 60, 0.88);
    border-radius: 6px;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/Expert/MyResume.vue